import { SortModel, SortType, } from "@/api/activity";
import { queryProductList } from "@/api/product";
import ProductWaterfall from "@/components/product-waterfall";
import { ProductModel } from "@akc/biz-api";
import React, { useEffect, useRef, useState } from "react";
interface IProps {
  activitySpuIdList?: string[];
  activityIdList?: string[];
}

const ProductList: React.FC<IProps> = ({
  activityIdList,
  activitySpuIdList
}) => {
  const [productList, setProductList] = useState<Array<ProductModel>>([]);
    const [hasNext, setHasNext] = useState(true);
    const currentRequestId = useRef(0);
    const currentPageNum = useRef<number>();
    const isLoading = useRef(false);

  /**
   * 查询商品列表
   * @returns 
   */
  const updateProductList = async () => {
    if (typeof currentPageNum.current === "undefined" || isLoading.current) {
      return;
    }
    currentRequestId.current = Math.floor(Math.random() * 10000000000);

    isLoading.current = true;
    // 档期详情商品列表默认逻辑
    let searchParams = {
      scene: "ACTIVITY_DETAIL",
      activityTypeGroup: 1,
      pageSize: 8,
      pageNum: currentPageNum.current,
      activityIdList,
      // thirdCategoryIdList: null,
      sortModel: SortModel.General,
      sortType: SortType.Asc,
    };
    const productReqList = activitySpuIdList?.map(spuId => ({ activitySpuId: spuId }));
    const res = await queryProductList(
      "H5_ScheduleDetail",
      searchParams,
      undefined,
      productReqList,
    );

    setHasNext(res?.hasNext ?? false);
    setProductList(productList => {
      return [
        ...productList,
        ...(res?.result?.map((item, index) => ({
          ...item,
          rank: productList.length + index,
        })) ?? []),
      ];
    });
    currentPageNum.current = (res?.pageIndex ?? 0) + 1;
    isLoading.current = false;
  };




  /**
   * 刷新商品列表
   */
  const resetProductList = () => {
    setProductList([]);
    setHasNext(true);
    currentPageNum.current = 1;
    updateProductList();
  };
  const onCartChange = () => {
    console.log("onCartChange");
  };

  useEffect(() => {
    resetProductList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityIdList, activitySpuIdList]);
  return (
    <ProductWaterfall
      productList={productList}
      hasNext={hasNext}
      loadMore={updateProductList}
      hasSidebar={false}
      provideBackground={false}
      topRightLocationCode="H5_ScheduleDetail_SmallList_ProductPicRight"
      titleFrontLocationCode="H5_ScheduleDetail_SmallList_TitleFront"
      titleBottomLocationCode="H5_ScheduleDetail_SmallList_TitleDown"
      onCartChange={onCartChange}
    />
  );
};

export default ProductList;
